export default __webpack_public_path__ + "static/media/background_near.13eadba0.svg";